import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { PRACTICE_GROUPS } from "./kvpData";
import KvpLayout, { CHARCOAL, COPPER, CREAM, SLATE } from "./KvpLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function KvpPracticeAreas() {
  return (
    <KvpLayout active="practice-areas">
      <section className="py-16 sm:py-20" style={{ background: CHARCOAL }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#E39A6E" }}>Practice Areas</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">Property, Business & Customs — Not Just "Full Service"</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8 space-y-8">
          {PRACTICE_GROUPS.map((g, i) => (
            <motion.div key={g.key} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }} className="bg-white rounded-lg p-6 sm:p-8 shadow-sm">
              <h3 className="font-bold text-xl mb-3" style={{ color: COPPER }}>{g.title}</h3>
              <div className="flex flex-wrap gap-2 mb-4">
                {g.areas.map((a) => (
                  <span key={a} className="text-xs font-medium rounded-full px-3.5 py-1.5" style={{ background: CREAM, color: CHARCOAL }}>{a}</span>
                ))}
              </div>
              {g.review && (
                <div className="mt-4 rounded-lg p-5 border-l-4" style={{ background: CREAM, borderColor: COPPER }}>
                  <Quote size={18} style={{ color: COPPER }} className="mb-2" />
                  <p className="text-sm" style={{ color: CHARCOAL }}>"{g.review.quote}"</p>
                  <p className="mt-2 text-xs" style={{ color: SLATE }}>— {g.review.author}, Lawzana review, {g.review.date}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </section>
    </KvpLayout>
  );
}
